
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import UIkit from 'uikit'

import BacModal from '@/components/BacModal.vue'
import BacButton from '@/components/BacButton.vue'
import BacLazyImage from '@/components/BacLazyImage.vue'
import { Http } from '@/lib/utils/Http'

@Component({
  components: {
    BacModal,
    BacButton,
    BacLazyImage
  }
})
export default class BacEditableImage extends Vue {
    @Prop({ default: false }) editMode!: boolean;
    @Prop({ required: true }) imagePath!: string;
    @Prop({ required: true }) imageEditUrl!: string;
    @Prop({ required: false, default: '' }) imageDeleteUrl!: string;
    @Prop({ default: '100%' }) width!: string;
    @Prop({ required: false, default: null }) bucket!: string | null;
    @Prop({ required: false, default: false }) onlyEmitDelete!: boolean;
    @Prop({ required: false, default: false }) legacy!: boolean;

    iconSize = 0
    deleteModalId = 'delete-modal' + Math.round(Math.random() * 100000000)
    isLoading = false

    mounted () {
      this.calculateIconSize()
    }

    @Watch('editMode')
    calculateIconSize () {
      this.iconSize = (this.$el as HTMLElement).offsetWidth / 6
      if (this.iconSize > 100) {
        this.iconSize = 100
      }
    }

    async deleteImage () {
      this.isLoading = true
      if (this.onlyEmitDelete) {
        this.$emit('delete')
        this.isLoading = false
        return
      }
      const res = await Http.request(this.imageDeleteUrl || this.imageEditUrl, {
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'DELETE'
      })
      if (res.status === 200) {
        UIkit.notification({
          message: 'Daten gespeichert!',
          status: 'success',
          timeout: 5000,
          pos: 'bottom-center'
        })
        this.$emit('successfulDelete')
      } else {
        UIkit.notification({
          message: 'Bild konnte nicht gelöscht werden, etwas ging schief! Bitte melde dich unter hello@backroadclub.com',
          status: 'success',
          timeout: 5000,
          pos: 'bottom-center'
        })
        console.error('error saving image, response: ', res)
      }
      this.isLoading = false
    }

    async uploadImage () {
      this.isLoading = true
      const file = ((this.$refs as any).imageUpload as any).files[0]
      const reader = new FileReader()
      reader.addEventListener('load', async (e) => {
        if (!e.target || !e.target.result) {
          throw new Error('Something bad happened trying to load image in FileReader! No Target or Target Result!')
        }
        const base64ImageData = btoa(e.target.result as string)
        const res = await Http.request(this.imageEditUrl, {
          headers: {
            'Content-Type': 'application/json'
          },
          method: 'POST',
          body: JSON.stringify({
            name: file.name,
            type: file.type,
            image: base64ImageData,
            bucket: this.bucket
          })
        })
        try {
          const resData = await res.json()
          if (res.status === 200) {
            UIkit.notification({
              message: 'Daten gespeichert!',
              status: 'success',
              timeout: 5000,
              pos: 'bottom-center'
            })
            this.$emit('successfullSave', resData)
          } else {
            UIkit.notification({
              message: 'Daten nicht gespeichert, etwas ging schief! Bitte kontaktiere uns sollte das Problem bestehen bleiben!',
              status: 'success',
              timeout: 5000,
              pos: 'bottom-center'
            })
            console.error('error saving image, response: ', resData)
          }
        } catch (ex) {
          UIkit.notification({
            message: 'Daten nicht gespeichert, etwas ging schief! Bitte kontaktiere uns sollte das Problem bestehen bleiben!',
            status: 'success',
            timeout: 5000,
            pos: 'bottom-center'
          })
          console.error('exception saving image, response: ', ex)
        }
      })
      reader.readAsBinaryString(file)

      setTimeout(() => {
        this.isLoading = false
      }, 5000)
    }
}
